import { infoContentSchema, type InfoContent } from '@/shared/types/infoContent';

export type HelpTopicId =
  | 'auth.login'
  | 'auth.signup'
  | 'onboarding.general'
  | 'onboarding.referred'
  | 'onboarding.vulnerability';

// Statically bundled help content. Could later be split per tenant pack.
const topics: Record<HelpTopicId, InfoContent> = {
  'auth.login': infoContentSchema.parse({
    title: 'Help: Login',
    sections: [
      {
        heading: 'Sign in with Email',
        bullets: [
          'Enter your email address to receive a secure magic link.',
          'Open the email on this device and click the link to continue.',
          'Check spam/junk if you do not see the email within a minute.'
        ]
      },
      {
        heading: 'Troubleshooting',
        bullets: [
          'Ensure your email is typed correctly.',
          'If rate limited, please wait for the countdown to finish before trying again.'
        ]
      }
    ]
  }),
  'auth.signup': infoContentSchema.parse({
    title: 'Help: Signup',
    sections: [
      {
        heading: 'Create your account',
        bullets: [
          'Use a valid email that you can access now.',
          'We will send a one-time link to verify ownership.'
        ]
      }
    ]
  }),
  'onboarding.general': infoContentSchema.parse({
    title: 'Help: Onboarding',
    sections: [
      {
        heading: 'What is onboarding?',
        body: 'A short set of steps to set up your profile and preferences.'
      },
      {
        heading: 'Tips',
        bullets: [
          'You can save and continue later.',
          'Fields marked as required must be completed before continuing.'
        ]
      }
    ]
  }),
  'onboarding.referred': infoContentSchema.parse({
    title: 'Help: Referred From',
    sections: [
      {
        heading: 'About this step',
        body: 'Tell us how you heard about IE Hub to help us improve our services.'
      },
      {
        heading: 'Options explained',
        bullets: [
          'Referred by a company: An organization shared IE Hub with you.',
          'Debt charity or advice service: A support service recommended IE Hub.',
          'Search engine / Social media / Friend or family: Self-discovery or word of mouth.'
        ]
      }
    ]
  }),
  'onboarding.vulnerability': infoContentSchema.parse({
    title: 'Help: Vulnerability',
    sections: [
      {
        heading: 'Why we ask',
        body: 'We ask sensitively to adapt support to your circumstances. Your information is protected.'
      },
      {
        heading: 'Examples',
        bullets: [
          'Health-related challenges',
          'Financial hardship',
          'Caring responsibilities',
          'Temporary life events impacting daily tasks'
        ]
      }
    ]
  })
};

export const helpTopics = topics;


